import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import Styles from "./VerticalTabs.module.css";
import { useTranslation } from "react-i18next";

function VerticalTabs({
	id,
	name,
	describe,
	cost,
	duration,
	startDate,
	schedule,
	state,
}) {
	const [value, setValue] = useState(0);
	const { t, i18n } = useTranslation();

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const scheduleKeys = Object.keys(schedule);
	const isStateExpired = state === "expired";
	const day1 = t("GuideProfile.day");

	return (
		<Box
			// Size of the module
			sx={{
				bgcolor: "background.paper",
				display: "flex",
				flexGrow: 1,
				height: "50vh",
				justifyContent: "space-between",
				// backgroundColor: "blue",
			}}
		>
			{/* this for tabs on the left side  */}
			<Tabs
				orientation='vertical'
				variant='scrollable'
				value={value}
				onChange={handleChange}
				aria-label='Vertical tabs example'
				sx={{
					// width: "100%",
					maxWidth: 80,
					borderRight: 2,
					borderColor: "divider",
					fontFamily: isRtl ? "Cairo" : "Ruda",
					direction: isRtl ? "rtl" : "ltr",
					minWidth: "70px",
					// backgroundColor: "pink",
				}}
			>
				{/* change tab text style*/}
				{/* overview Tab */}
				<Tab
					label={t("GuideProfile.overView")}
					{...a11yProps(0)}
					sx={{
						fontFamily: isRtl ? "Cairo" : "Ruda",
						direction: isRtl ? "rtl" : "ltr",
						textTransform: "none",
						fontSize: "0.9rem",
						fontWeight: 900,
						padding: 0,
						flexWrap: "wrap",
						minWidth: "20px",
					}}
				/>

				{/* Days Tab */}
				{scheduleKeys.map((day, index) => (
					<Tab
						key={index + 1}
						label={`${day1} ${index + 1}`}
						{...a11yProps(index + 1)}
						sx={{
							fontFamily: isRtl ? "Cairo" : "Ruda",
							direction: isRtl ? "rtl" : "ltr",
							textTransform: "none",
							fontSize: "0.8rem",
							fontWeight: 900,
							padding: 0,
							flexWrap: "wrap",
							minWidth: "30px",
						}}
					/>
				))}
				{/* Book Now Tab */}
				<Tab
					label={t("GuideProfile.book")}
					{...a11yProps(scheduleKeys.length + 1)}
					disabled={isStateExpired}
					sx={{
						fontFamily: isRtl ? "Cairo" : "Ruda",
						direction: isRtl ? "rtl" : "ltr",
						textTransform: "none",
						fontSize: "0.8rem",
						fontWeight: 900,
						padding: 0,
						flexWrap: "wrap",
						minWidth: "30px",
					}}
				/>
			</Tabs>

			{/* Overview Section */}
			<TabPanel
				value={value}
				index={0}
			>
				<Typography
					sx={{
						maxWidth: 600,
						width: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						fontWeight: 800,
						color: "#003483",
						fontFamily: isRtl ? "Cairo" : "Ruda",
						direction: isRtl ? "rtl" : "ltr",
					}}
				>
					{t("GuideProfile.overView")}
					<span
						style={{
							color: "#0077B6",
							fontWeight: 600,
							padding: "0",
							fontSize: "1rem",
							textAlign: "center",
						}}
					>
						{name}
					</span>
					<br />

					<p
						style={{
							lineHeight: "140%",
							letterSpacing: "120%",
							fontWeight: 600,
							paddingBottom: 8,
							color: "#5E5E5E",
						}}
					>
						{startDate} إرشاد هافال جعل زيارتي إلى العراق
						استثنائية. المعرفة العميقة بالثقافة والتاريخ،
						بالإضافة إلى السعة الدافئة والودودة، خلقت تجربة
						لا تُنسى. أنا ممتن لخبرة هافال وأوصي به بشدة
						كدليل. This will change
					</p>
				</Typography>
			</TabPanel>

			{/* Trip Scheduale Section */}
			{scheduleKeys.map((day, index) => (
				<TabPanel
					key={index + 1}
					value={value}
					index={index + 1}
					orientation='vertical'
					variant='scrollable'
					// sx={{
					// 	fontWeight: "bold",
					// 	color: "#003483",
					// }}
				>
					<Typography
						sx={{
							maxWidth: 600,
							width: "100%",
							display: "flex",
							justifyContent: "center",
							flexDirection: "column",
							fontWeight: 800,
							color: "#003483",
							fontFamily: isRtl ? "Cairo" : "Ruda",
							direction: isRtl ? "rtl" : "ltr",
						}}
					>
						<h3>
							{t("GuideProfile.day")} {index + 1} :
							{schedule[day].title}
							<hr className={Styles.line} />
						</h3>
						{schedule[day].activities.map(
							(activity, activityIndex) => (
								<p
									key={activityIndex}
									style={{
										lineHeight: "140%",
										letterSpacing: "120%",
										fontWeight: 600,
										paddingBottom: 8,
										color: "#5E5E5E",
									}}
								>
									{/* numbering */}
									<span
										style={{
											lineHeight: "140%",
											letterSpacing: "120%",
											fontWeight: 800,
											paddingRight: 4,
											color: "#003483",
										}}
									>
										{activityIndex + 1}.
									</span>
									{activity}
								</p>
							)
						)}
					</Typography>
				</TabPanel>
			))}

			{/* Book Now Section */}
			<TabPanel
				value={value}
				index={scheduleKeys.length + 1}
				orientation='vertical'
				variant='scrollable'
			>
				<Typography
					sx={{
						width: "100%",
						maxWidth: 400,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						fontFamily: isRtl ? "Cairo" : "Ruda",
						direction: isRtl ? "rtl" : "ltr",
						color: "#5E5E5E",
					}}
				>
					{t("GuideProfile.bookingDetails")}
					<br />
					<span
						style={{
							color: "#0077B6",
							fontWeight: 600,
							padding: "2px",
						}}
					>
						{name}
					</span>
					<br />
					إرشاد هافال جعل زيارتي إلى العراق استثنائية.
					المعرفة العميقة بالثقافة والتاريخ، بالإضافة إلى
					السعة الدافئة والودودة، خلقت تجربة لا تُنسى. أنا
					ممتن لخبرة هافال وأوصي به بشدة كدليل. This will
					change
					<br />
					<button
						className={Styles.btn}
						style={{ marginTop: "10px" }}
						onClick={() => {
							console.log("Book Now clicked");
						}}
					>
						{t("GuideProfile.book")}
					</button>
				</Typography>
			</TabPanel>
		</Box>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`vertical-tabpanel-${index}`}
			aria-labelledby={`vertical-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `vertical-tab-${index}`,
		"aria-controls": `vertical-tabpanel-${index}`,
	};
}

export default VerticalTabs;
